import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {AppProvider} from "./utils/AppContext";
import Layout from './components/Layout';
import Home from "./screens/Home";
import About from "./screens/About";
import Terms from "./screens/Terms";
import Privacy from "./screens/Privacy";
import "./styles/Styles.css";

const App = () => {

    return (
        <Router>
            <AppProvider>
                 <Routes>
                    <Route path="/" element={<Layout/>}>
                        <Route index element={<Home/>}/>
                        <Route path="/about" element={<About/>}/>
                        <Route path="/terms" element={<Terms/>}/>
                        <Route path="/privacy" element={<Privacy/>}/>
                    </Route>
                </Routes>
             </AppProvider>
        </Router>
    );

}

export default App;
